module.exports = __webpack_public_path__ + "img/loading-Infinity.5631de94.gif";